import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LockKeyhole } from 'lucide-react';
import FooterNew from '../components/FooterNew';
import { getBackendUrl, setAdminSession } from '../utils/auth';

const AdminLogin = () => {
  const navigate = useNavigate();
  const backendUrl = useMemo(() => getBackendUrl(), []);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${backendUrl}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const payload = await response.json();
      if (!response.ok || !payload.success) {
        throw new Error(payload.message || 'Login failed');
      }

      setAdminSession(payload.token);
      navigate('/admin/social-posts', { replace: true });
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="bg-primary min-h-screen pt-28">
      <section className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="rounded-2xl p-8"
          style={{
            background: 'linear-gradient(145deg, rgba(15, 23, 42, 0.9), rgba(30, 41, 59, 0.75))',
            border: '1px solid rgba(99, 102, 241, 0.2)',
          }}
        >
          <h1 className="text-3xl font-bold text-white text-center mb-2">Admin Login</h1>
          <p className="text-slate-400 text-center mb-6">Social media content panel access ke liye login karein.</p>

          {error ? <p className="text-rose-300 text-sm mb-4">{error}</p> : null}

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              required
              value={formData.email}
              onChange={(event) => setFormData((prev) => ({ ...prev, email: event.target.value }))}
              placeholder="Admin Email"
              className="w-full px-4 py-3 rounded-xl bg-surface/60 border border-accent/20 text-white"
            />
            <input
              type="password"
              required
              value={formData.password}
              onChange={(event) => setFormData((prev) => ({ ...prev, password: event.target.value }))}
              placeholder="Admin Password"
              className="w-full px-4 py-3 rounded-xl bg-surface/60 border border-accent/20 text-white"
            />

            <button type="submit" disabled={loading} className="neon-btn neon-btn-primary w-full justify-center">
              <LockKeyhole className="w-4 h-4" />
              {loading ? 'Signing in...' : 'Login as Admin'}
            </button>
          </form>
        </motion.div>
      </section>
      <FooterNew />
    </main>
  );
};

export default AdminLogin;
